module.exports = __webpack_public_path__ + "img/login_bg.f80862e5.jpg";